import '../../../static/css/pages/dashboard/overview.css';
import {Link} from "react-router-dom";
import {
    ThinAbsentIcon,
    ThinAdvertisingIcon,
    ThinArrowLeft,
    ThinBadgeIcon,
    ThinBuildingIcon,
    ThinChart2Icon,
    ThinClassIcon, ThinConsentIcon,
    ThinExtraPaymentIcon,
    ThinnerPeopleIcon,
    ThinnerSMSIcon, ThinSettingIcon,
    ThinStoreIcon, ThinTaskIcon
} from "../../../components/icons/material-icons";
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    defaults,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from "chart.js";
import {Doughnut, Line} from "react-chartjs-2";
import {useEffect, useState} from "react";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {HideProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

defaults.font.family = 'estedad';
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
);

export const AdminsOverviewScreen = () => {
    const [data, setData] = useState({
        loaded: true,
        customers: 310,
        smsBudget: 199000,
        totalCustomerDept: 2900000,
        receivedSms: 15,
    });
    const [canSeeCharts, setCanSeeCharts] = useState(false);
    const [access, setAccess] = useState({
        canStudents: false,
        canFinance: false,
        canClasses: false,
        canAttend: false,
        canPoint: false,
        canSciCenter: false,
        canExtraPayments: false,
        canNews: false,
        canConsents: false,
        canTickets: false,
        canStaff: false,
        canSettings: false,
    })
    const [presentChart, setPresentChart] = useState({
        backgroundColors: [] as string[],
        borderColors: [] as string[],
        numbers: [] as number[],
        labels: [] as string[],
    });
    const [revenueChart, setRevenueChart] = useState({
        store: [] as number[],
        labels: [] as string[],
        tuition: [] as number[],
    });
    const fetchDashboardData = () => {
        PostJSON(
            Apis.server + '/core/admins/dashboard/overview',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                countDept: number,
                students: number,
                tuition: {
                    day: string,
                    total: number,
                }[],
                store: {
                    day: string,
                    total: number,
                }[],
                charts: 0 | 1,
                canStudents: 0 | 1,
                canFinance: 0 | 1,
                canClasses: 0 | 1,
                canAttend: 0 | 1,
                canPoint: 0 | 1,
                canSciCenter: 0 | 1,
                canExtraPayments: 0 | 1,
                canNews: 0 | 1,
                canConsents: 0 | 1,
                canTickets: 0 | 1,
                canStaff: 0 | 1,
                canSettings: 0 | 1,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                const colors = generateColors(5);
                let tuitionChart = [] as number[];
                let chartLabels = [] as string[];
                let storeChart = [] as number[];
                d.tuition.forEach(t => {
                    chartLabels.push(StringDigitsConvertToPersian(GregorianToPersian(t.day)).replaceAll('-', '/'));
                    tuitionChart.push(t.total);
                });
                d.store.forEach(t => {
                    storeChart.push(t.total);
                });
                setRevenueChart({
                    labels: chartLabels,
                    store: storeChart,
                    tuition: tuitionChart,
                });
                setPresentChart({
                    numbers: [d.students - d.countDept, d.countDept],
                    labels: ['تکمیل پرداخت', 'بدهکار شهریه'],
                    borderColors: colors.borderColor,
                    backgroundColors: colors.backgroundColor,
                });
                setCanSeeCharts(d.charts === 1);
                setAccess({
                    canStudents: d.canStudents === 1,
                    canFinance: d.canFinance === 1,
                    canClasses: d.canClasses === 1,
                    canAttend: d.canAttend === 1,
                    canPoint: d.canPoint === 1,
                    canSciCenter: d.canSciCenter === 1,
                    canExtraPayments: d.canExtraPayments === 1,
                    canNews: d.canNews === 1,
                    canConsents: d.canConsents === 1,
                    canTickets: d.canTickets === 1,
                    canStaff: d.canStaff === 1,
                    canSettings: d.canSettings === 1,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "داشبورد | اتوماسیون نهال";
        fetchDashboardData();
    }, []);
    const showNotPurchasedError = () => {
        ShowSnackbar(
            'این امکان برای مدرسه شما فعال نشده است.',
            'باشه',
            5000,
        );
    };
    return (
        <>
            <BreadCrumbs links={[{title: 'اتوماسیون', url: `/admins/overview`}]}/>
            {
                data.loaded ?
                    <div data-aos="fade-up" data-aos-duration="1000">
                        <div className="container">
                            <div className="row" style={{marginTop: 30}}>
                                {
                                    access.canStudents ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/students"
                                                  className="dashboard--buttons"
                                                  style={{backgroundColor: '#0a53be'}}>
                                                <i><ThinnerPeopleIcon/></i>
                                                <b>دانش‌آموزان</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                {
                                    access.canFinance ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/finance"
                                                  className="dashboard--buttons"
                                                  style={{backgroundColor: 'darkgreen'}}>
                                                <i><ThinChart2Icon/></i>
                                                <b>امورمالی</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                {
                                    access.canClasses ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/classes"
                                                  className="dashboard--buttons"
                                                  style={{backgroundColor: '#8b0000'}}>
                                                <i><ThinClassIcon/></i>
                                                <b>کلاس‌بندی</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                {
                                    access.canAttend ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/attend"
                                                  className="dashboard--buttons"
                                                  style={{backgroundColor: 'darkgoldenrod'}}>
                                                <i><ThinAbsentIcon/></i>
                                                <b>حضورغیاب</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                {
                                    access.canPoint ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/store"
                                                // onClick={showNotPurchasedError}
                                                className="dashboard--buttons"
                                                style={{backgroundColor: '#8b008b'}}>
                                                <i><ThinStoreIcon/></i>
                                                <b>بوفه</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                {
                                    access.canSciCenter ?
                                        <div className="col-lg-2 col-md-6">
                                            <button
                                                //to="/admins/center"
                                                className="dashboard--buttons"
                                                onClick={showNotPurchasedError}
                                                style={{backgroundColor: '#b33e00'}}>
                                                <i><ThinBuildingIcon/></i>
                                                <b>کلاس فوق‌برنامه</b>
                                                <ThinArrowLeft/>
                                            </button>
                                        </div> : null
                                }
                                {
                                    access.canNews ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/news"
                                                // onClick={showNotPurchasedError}
                                                className="dashboard--buttons"
                                                style={{backgroundColor: '#007e80'}}>
                                                <i><ThinAdvertisingIcon/></i>
                                                <b>اطلاعیه‌ها</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                <div className="col-lg-2 col-md-6">
                                    <Link to="/admins/presignup"
                                          className="dashboard--buttons"
                                          style={{backgroundColor: '#2200cf'}}>
                                        <i><ThinTaskIcon/></i>
                                        <b>پیش ثبت‌نام</b>
                                        <ThinArrowLeft/>
                                    </Link>
                                </div>
                                {
                                    access.canStaff ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/staff"
                                               // onClick={showNotPurchasedError}
                                                className="dashboard--buttons"
                                                style={{backgroundColor: '#5c5505'}}>
                                                <i><ThinBadgeIcon/></i>
                                                <b>منابع انسانی</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                                {
                                    access.canExtraPayments ?
                                        <div className="col-lg-2 col-md-6">
                                            <button //to="/admins/extra"
                                                onClick={showNotPurchasedError}
                                                className="dashboard--buttons"
                                                style={{backgroundColor: '#055c55'}}>
                                                <i><ThinExtraPaymentIcon/></i>
                                                <b>پرداخت متفرقه</b>
                                                <ThinArrowLeft/>
                                            </button>
                                        </div> : null
                                }
                                {
                                    access.canConsents ?
                                        <div className="col-lg-2 col-md-6">
                                            <button //to="/admins/consents"
                                                onClick={showNotPurchasedError}
                                                className="dashboard--buttons"
                                                style={{backgroundColor: '#470202'}}>
                                                <i><ThinConsentIcon/></i>
                                                <b>رضایت‌نامه ها</b>
                                                <ThinArrowLeft/>
                                            </button>
                                        </div> : null
                                }
                                {
                                    access.canSettings ?
                                        <div className="col-lg-2 col-md-6">
                                            <Link to="/admins/settings"
                                                  className="dashboard--buttons"
                                                  style={{backgroundColor: '#404702'}}>
                                                <i><ThinSettingIcon/></i>
                                                <b>تنظیمات</b>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div> : null
                                }
                            </div>
                            {
                                canSeeCharts ?
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="dashboard--chart">
                                                <b>نمودار درآمد</b>
                                                <Line data={{
                                                    labels: revenueChart.labels,
                                                    datasets: [
                                                        {
                                                            label: 'شهریه',
                                                            data: revenueChart.tuition,
                                                            borderColor: 'rgb(255, 99, 132)',
                                                            backgroundColor: 'rgba(255, 99, 132, 0.5)',
                                                        },
                                                        {
                                                            label: 'فروشگاه',
                                                            data: revenueChart.store,
                                                            borderColor: 'rgb(0, 100, 255,0.4)',
                                                            backgroundColor: 'rgba(0,100,255, 0.5)',
                                                        },
                                                    ],
                                                }}/>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="dashboard--chart">
                                                <b>وضعیت شهریه</b>
                                                <Doughnut data={{
                                                    labels: presentChart.labels,
                                                    datasets: [
                                                        {
                                                            label: 'دانش‌آموز',
                                                            data: presentChart.numbers,
                                                            backgroundColor: presentChart.backgroundColors,
                                                            borderColor: presentChart.borderColors,
                                                            borderWidth: 1,
                                                        },
                                                    ],
                                                }}/>
                                            </div>
                                        </div>
                                    </div> : null
                            }
                        </div>
                    </div> : null
            }
        </>
    );
};

export function generateColors(howManyRecords: number) {
    let colors = {
        backgroundColor: [] as string[],
        borderColor: [] as string[],
    };
    for (let i = 0; i < howManyRecords; i++) {
        let red, green, blue;
        do {
            red = Math.floor(Math.random() * 256);
            green = Math.floor(Math.random() * 256);
            blue = Math.floor(Math.random() * 256);
        } while (red === 255 && green === 255 && blue === 255);

        const offset = 30; // Adjust this value to control the range of randomness

        const randomRed = Math.max(0, Math.min(255, red + Math.floor(Math.random() * offset) - offset / 2));
        const randomGreen = Math.max(0, Math.min(255, green + Math.floor(Math.random() * offset) - offset / 2));
        const randomBlue = Math.max(0, Math.min(255, blue + Math.floor(Math.random() * offset) - offset / 2));

        const backgroundColor = `rgba(${randomRed}, ${randomGreen}, ${randomBlue}, 0.2)`;
        const borderColor = `rgba(${randomRed}, ${randomGreen}, ${randomBlue}, 1)`;

        colors.backgroundColor.push(backgroundColor);
        colors.borderColor.push(borderColor);
    }
    return colors;
}